// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginPageStyle_userModalContainer__MMot7 {
  margin: 1em 2.2em 2.2em 2em;
  overflow-y: scroll;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.loginPageStyle_userModalContainer__MMot7::-webkit-scrollbar {
  display: none !important;
}

/* Hide scrollbar for IE, Edge and Firefox */
.loginPageStyle_userModalContainer__MMot7 {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.loginPageStyle_requiredText__KQcko {
  font-weight: bold;
  opacity: 0.6;
  margin-bottom: 0;
}

.loginPageStyle_inputAdornment__geFNF {
  margin-right: 18px;
}

.loginPageStyle_inputAdornmentIcon__E0jf8 {
  color: var(--inputGray);
}

selector input[type="number"]::-webkit-outer-spin-button,
selector input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.loginPageStyle_pd__zf94N {
  padding: 1rem;
}

.loginPageStyle_pd2__joSbH {
  padding: 1.5rem;
}

.loginPageStyle_pdLeft__6hckg {
  padding-left: 0.9rem;
}

.loginPageStyle_pdLeft1__1cQij {
  padding-left: 1rem;
}

.loginPageStyle_pdLeftRight__KySq5 {
  padding: 0 1rem 1rem 1rem;
}
.loginPageStyle_pdRight__MAAcQ {
  padding-right: 1rem;
}

.loginPageStyle_pdRight50__IRzIn {
  padding-right: 0.5rem;
}

.loginPageStyle_pdbottom__vVbv6 {
  padding-bottom: 1rem;
}

.loginPageStyle_pdTop__2cVbO {
  padding-top: 1rem;
}

.loginPageStyle_pdRmv__NUO59 {
  padding: 0 !important;
}

.loginPageStyle_flexClm__j3hIN {
  display: flex;
  flex-direction: column;
}

.loginPageStyle_flexR__F6x4Y {
  display: flex;
  flex-direction: row;
}

.loginPageStyle_flexRAlgn__Vs1ju {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loginPageStyle_flexRMrg__-AbbK {
  display: flex;
  flex-direction: row;
  margin: 1rem;
}

.loginPageStyle_flRg__lvYoT {
  float: right;
}

.loginPageStyle_mrg__i1-Ei {
  margin: 1rem;
}

.loginPageStyle_mrgTop__iSFvS {
  margin-top: 2em !important;
}

.loginPageStyle_mrrg__rN5Cv {
  margin-right: 1em;
}

.loginPageStyle_mrgLeft__xNQfP {
  margin-left: 0.5em;
}

.loginPageStyle_containerBtn__E2s\\+8 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
}

.loginPageStyle_modalCancelBtn__amJ\\+E {
  margin: 0 1em 0 0;
  height: 40px;
  width: 8em;
}

.loginPageStyle_modalAcceptBtn__TizRj {
  margin: 0 0 0 1em;
  height: 40px;
  width: 8em;
}

.loginPageStyle_width6__YSE5m {
  width: 6em;
}

.loginPageStyle_addressTitle__B5GKF {
  font-weight: bold;
  opacity: 0.6;
  margin-right: auto;
}

.loginPageStyle_smallText__FcbX7 {
  font-weight: bold;
  opacity: 0.6;
}

.loginPageStyle_cardHeader__RnEG- {
  width: 6rem;
  border-radius: 3px;
  padding-left: 1rem;
}

.loginPageStyle_cardtitle__IN643 {
  text-decoration: none;
  font-weight: 300;
  min-height: 32px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  color: var(--black);
  font-weight: bold;
}

.loginPageStyle_forgottenPassword__6i7Up {
  hyphens: auto;
  word-break: break-word;
}

.loginPageStyle_forgottenPassword__6i7Up:hover {
  cursor: pointer;
}

.loginPageStyle_card__qDs7n {
  color: var(--black);
  width: 100%;
  border: 0;
  display: flex;
  position: relative;
  font-size: 0.875rem;
  min-width: 0;
  word-wrap: break-word;
  background: var(--cardBackground);
  box-shadow: 0 1px 4px 0 var(--shadow);
  margin-top: 30px;
  border-radius: 6px;
  margin-bottom: 30px;
  flex-direction: column;
}

.loginPageStyle_loginCardWidth__BvKWB {
  width: 40em;
}

.loginPageStyle_cardDraftEdit__8YA2B {
  color: var(--black70);
  width: 100%;
  border: 0;
  display: flex;
  position: relative;
  font-size: 0.875rem;
  min-width: 0;
  word-wrap: break-word;
  background: var(--cardBackground);
  margin-top: 30px;
  border-radius: 3px;
  margin-bottom: 30px;
  flex-direction: column;
}

.loginPageStyle_cardDraftEditDisabled__QNT4G {
  background: #bfdcdc;
}

.loginPageStyle_loginBtn__BJ8t3 {
  border-radius: 0px !important;
  max-height: 40px;
  width: 7.5rem;
  background: var(--header) !important;
  font-weight: bold;
  color: var(--white) !important;
  float: right;
}

.loginPageStyle_loginBtn__BJ8t3:hover {
  color: var(--header);
  border: 1px solid var(--header);
  background: var(--white);
}

.loginPageStyle_draftCardsHeader__0sjT4 {
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase;
  color: var(--black70);
}

.loginPageStyle_txAlgn__XS-aE {
  text-align: center !important;
}

.loginPageStyle_headerBcg__y\\+w0O {
  background: var(--header);
  height: 4em;
}

.loginPageStyle_uploadBtn__2296x {
  background: var(--buttonYellow);
}

.loginPageStyle_uploadingRow__1FF-F {
  background-color: rgba(224, 169, 0, 0.06);
  animation: loginPageStyle_uploadingRowPulse__G6m-H 1.8s ease-in-out infinite;
}

.loginPageStyle_uploadingPreview__Pf\\+hD {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 72px;
  width: 108px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e4e4e4;
  background-image: linear-gradient(
    100deg,
    #e4e4e4 30%,
    #f2f2f2 50%,
    #e4e4e4 70%
  );
  background-size: 220% 100%;
  animation: loginPageStyle_uploadingShimmer__\\+jqHb 1.4s linear infinite;
}

.loginPageStyle_uploadingInfo__RSXYi {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.loginPageStyle_uploadingName__XtO4B {
  font-weight: 700;
  color: var(--black);
}

.loginPageStyle_uploadingStatus__8aTvd {
  font-size: 0.8rem;
  color: var(--black75);
}

@keyframes loginPageStyle_uploadingShimmer__\\+jqHb {
  from {
    background-position: 220% 0;
  }
  to {
    background-position: -20% 0;
  }
}

@keyframes loginPageStyle_uploadingRowPulse__G6m-H {
  0%,
  100% {
    background-color: rgba(224, 169, 0, 0.05);
  }
  50% {
    background-color: rgba(224, 169, 0, 0.11);
  }
}

@media screen and (max-width: 1000px) {
  .loginPageStyle_uploadingPreview__Pf\\+hD {
    height: 36px;
    width: 54px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loginPageStyle_uploadingRow__1FF-F,
  .loginPageStyle_uploadingPreview__Pf\\+hD {
    animation: none;
  }
}

.loginPageStyle_clrWhite__PBhTU {
  color: var(--white);
}

.loginPageStyle_draftTitle__79WPX {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: x-large;
}

.loginPageStyle_draftBtnContainer__rZRP8 {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 100000;
}

.loginPageStyle_draftBackBtn__l-oBx {
  border-radius: 0px !important;
  max-height: 40px;
  width: 10rem;
  background: var(--mainRed) !important;
  color: var(--white) !important;
}

.loginPageStyle_draftBackBtn__l-oBx:hover {
  color: var(--mainRed) !important;
  border: 1px solid var(--mainRed) !important;
  background: var(--white) !important;
}

.loginPageStyle_draftSaveBtn__xrVM9 {
  border-radius: 0px !important;
  max-height: 40px;
  width: 10rem;
  background: var(--header) !important;
  color: var(--white) !important;
}

.loginPageStyle_draftSaveBtn__xrVM9:hover {
  color: var(--header) !important;
  border: 1px solid var(--header) !important;
  background: var(--white) !important;
}

.loginPageStyle_priorityContainer__hiPLX {
  display: flex;
  margin-top: 10px;
  padding-bottom: 20px;
  gap: 1em;
}

.loginPageStyle_tdContainer__qgzEq {
  color: var(--white);
  padding: 0;
  padding-left: 0.5rem;
}

.loginPageStyle_tdBtnContainer__QmCvD {
  padding-left: 1rem;
  display: flex;
  gap: 1em;
  align-items: center;
  color: var(--white);
}

.loginPageStyle_checkboxContainer__esUtl {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.loginPageStyle_opacity60__jgKgT {
  opacity: 0.6px;
}

.loginPageStyle_dsplInBlock__we2Tm {
  display: inline-block;
}

.loginPageStyle_fontSize90__yzsKd {
  font-size: 0.9rem;
}

.loginPageStyle_fontSize70__y6Cvo {
  font-size: 0.7rem;
}

.loginPageStyle_calcBoldTitle__FH1Ib {
  color: #000;
  padding-left: 1rem;
  font-size: 1.5rem;
}

.loginPageStyle_calcTitle__1QxVn {
  opacity: 0.6;
  text-transform: uppercase;
}

.loginPageStyle_borderBottomNone__H9s57 {
  border-bottom: none;
}

.loginPageStyle_fntWeightBold__I6veU {
  font-weight: bold;
}

.loginPageStyle_leftInputContainer__iPCp9 {
  padding-right: 1rem;
  width: 13rem;
}

.loginPageStyle_rightInputContainer__gUKoI {
  width: 13rem;
}

.loginPageStyle_searchCompany__MvB3s {
  width: 27rem;
}

.loginPageStyle_billingShippingContainer__EQF4c {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  margin-bottom: 1rem;
}

.loginPageStyle_twoColumnField__6XPb6 {
  flex: 1 1;
}

.loginPageStyle_addressColumn__MS7Fy {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loginPageStyle_fieldSubLabel__nEukJ {
  font-size: 0.75rem;
  color: var(--inputGray, #888);
  margin-top: 2px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/Styles/loginPageStyle.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uDAAuD;EACvD,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,4EAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB;;;;;GAKC;EACD,0BAA0B;EAC1B,uEAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB","sourcesContent":[".userModalContainer {\n  margin: 1em 2.2em 2.2em 2em;\n  overflow-y: scroll;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.userModalContainer::-webkit-scrollbar {\n  display: none !important;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.userModalContainer {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.requiredText {\n  font-weight: bold;\n  opacity: 0.6;\n  margin-bottom: 0;\n}\n\n.inputAdornment {\n  margin-right: 18px;\n}\n\n.inputAdornmentIcon {\n  color: var(--inputGray);\n}\n\nselector input[type=\"number\"]::-webkit-outer-spin-button,\nselector input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.pd {\n  padding: 1rem;\n}\n\n.pd2 {\n  padding: 1.5rem;\n}\n\n.pdLeft {\n  padding-left: 0.9rem;\n}\n\n.pdLeft1 {\n  padding-left: 1rem;\n}\n\n.pdLeftRight {\n  padding: 0 1rem 1rem 1rem;\n}\n.pdRight {\n  padding-right: 1rem;\n}\n\n.pdRight50 {\n  padding-right: 0.5rem;\n}\n\n.pdbottom {\n  padding-bottom: 1rem;\n}\n\n.pdTop {\n  padding-top: 1rem;\n}\n\n.pdRmv {\n  padding: 0 !important;\n}\n\n.flexClm {\n  display: flex;\n  flex-direction: column;\n}\n\n.flexR {\n  display: flex;\n  flex-direction: row;\n}\n\n.flexRAlgn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.flexRMrg {\n  display: flex;\n  flex-direction: row;\n  margin: 1rem;\n}\n\n.flRg {\n  float: right;\n}\n\n.mrg {\n  margin: 1rem;\n}\n\n.mrgTop {\n  margin-top: 2em !important;\n}\n\n.mrrg {\n  margin-right: 1em;\n}\n\n.mrgLeft {\n  margin-left: 0.5em;\n}\n\n.containerBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1em;\n}\n\n.modalCancelBtn {\n  margin: 0 1em 0 0;\n  height: 40px;\n  width: 8em;\n}\n\n.modalAcceptBtn {\n  margin: 0 0 0 1em;\n  height: 40px;\n  width: 8em;\n}\n\n.width6 {\n  width: 6em;\n}\n\n.addressTitle {\n  font-weight: bold;\n  opacity: 0.6;\n  margin-right: auto;\n}\n\n.smallText {\n  font-weight: bold;\n  opacity: 0.6;\n}\n\n.cardHeader {\n  width: 6rem;\n  border-radius: 3px;\n  padding-left: 1rem;\n}\n\n.cardtitle {\n  text-decoration: none;\n  font-weight: 300;\n  min-height: 32px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  color: var(--black);\n  font-weight: bold;\n}\n\n.forgottenPassword {\n  hyphens: auto;\n  word-break: break-word;\n}\n\n.forgottenPassword:hover {\n  cursor: pointer;\n}\n\n.card {\n  color: var(--black);\n  width: 100%;\n  border: 0;\n  display: flex;\n  position: relative;\n  font-size: 0.875rem;\n  min-width: 0;\n  word-wrap: break-word;\n  background: var(--cardBackground);\n  box-shadow: 0 1px 4px 0 var(--shadow);\n  margin-top: 30px;\n  border-radius: 6px;\n  margin-bottom: 30px;\n  flex-direction: column;\n}\n\n.loginCardWidth {\n  width: 40em;\n}\n\n.cardDraftEdit {\n  color: var(--black70);\n  width: 100%;\n  border: 0;\n  display: flex;\n  position: relative;\n  font-size: 0.875rem;\n  min-width: 0;\n  word-wrap: break-word;\n  background: var(--cardBackground);\n  margin-top: 30px;\n  border-radius: 3px;\n  margin-bottom: 30px;\n  flex-direction: column;\n}\n\n.cardDraftEditDisabled {\n  background: #bfdcdc;\n}\n\n.loginBtn {\n  border-radius: 0px !important;\n  max-height: 40px;\n  width: 7.5rem;\n  background: var(--header) !important;\n  font-weight: bold;\n  color: var(--white) !important;\n  float: right;\n}\n\n.loginBtn:hover {\n  color: var(--header);\n  border: 1px solid var(--header);\n  background: var(--white);\n}\n\n.draftCardsHeader {\n  font-weight: bold;\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  color: var(--black70);\n}\n\n.txAlgn {\n  text-align: center !important;\n}\n\n.headerBcg {\n  background: var(--header);\n  height: 4em;\n}\n\n.uploadBtn {\n  background: var(--buttonYellow);\n}\n\n.uploadingRow {\n  background-color: rgba(224, 169, 0, 0.06);\n  animation: uploadingRowPulse 1.8s ease-in-out infinite;\n}\n\n.uploadingPreview {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 72px;\n  width: 108px;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #e4e4e4;\n  background-image: linear-gradient(\n    100deg,\n    #e4e4e4 30%,\n    #f2f2f2 50%,\n    #e4e4e4 70%\n  );\n  background-size: 220% 100%;\n  animation: uploadingShimmer 1.4s linear infinite;\n}\n\n.uploadingInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.uploadingName {\n  font-weight: 700;\n  color: var(--black);\n}\n\n.uploadingStatus {\n  font-size: 0.8rem;\n  color: var(--black75);\n}\n\n@keyframes uploadingShimmer {\n  from {\n    background-position: 220% 0;\n  }\n  to {\n    background-position: -20% 0;\n  }\n}\n\n@keyframes uploadingRowPulse {\n  0%,\n  100% {\n    background-color: rgba(224, 169, 0, 0.05);\n  }\n  50% {\n    background-color: rgba(224, 169, 0, 0.11);\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .uploadingPreview {\n    height: 36px;\n    width: 54px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .uploadingRow,\n  .uploadingPreview {\n    animation: none;\n  }\n}\n\n.clrWhite {\n  color: var(--white);\n}\n\n.draftTitle {\n  width: 100%;\n  text-align: center;\n  font-weight: bold;\n  font-size: x-large;\n}\n\n.draftBtnContainer {\n  position: fixed;\n  top: 16px;\n  right: 16px;\n  z-index: 100000;\n}\n\n.draftBackBtn {\n  border-radius: 0px !important;\n  max-height: 40px;\n  width: 10rem;\n  background: var(--mainRed) !important;\n  color: var(--white) !important;\n}\n\n.draftBackBtn:hover {\n  color: var(--mainRed) !important;\n  border: 1px solid var(--mainRed) !important;\n  background: var(--white) !important;\n}\n\n.draftSaveBtn {\n  border-radius: 0px !important;\n  max-height: 40px;\n  width: 10rem;\n  background: var(--header) !important;\n  color: var(--white) !important;\n}\n\n.draftSaveBtn:hover {\n  color: var(--header) !important;\n  border: 1px solid var(--header) !important;\n  background: var(--white) !important;\n}\n\n.priorityContainer {\n  display: flex;\n  margin-top: 10px;\n  padding-bottom: 20px;\n  gap: 1em;\n}\n\n.tdContainer {\n  color: var(--white);\n  padding: 0;\n  padding-left: 0.5rem;\n}\n\n.tdBtnContainer {\n  padding-left: 1rem;\n  display: flex;\n  gap: 1em;\n  align-items: center;\n  color: var(--white);\n}\n\n.checkboxContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.opacity60 {\n  opacity: 0.6px;\n}\n\n.dsplInBlock {\n  display: inline-block;\n}\n\n.fontSize90 {\n  font-size: 0.9rem;\n}\n\n.fontSize70 {\n  font-size: 0.7rem;\n}\n\n.calcBoldTitle {\n  color: #000;\n  padding-left: 1rem;\n  font-size: 1.5rem;\n}\n\n.calcTitle {\n  opacity: 0.6;\n  text-transform: uppercase;\n}\n\n.borderBottomNone {\n  border-bottom: none;\n}\n\n.fntWeightBold {\n  font-weight: bold;\n}\n\n.leftInputContainer {\n  padding-right: 1rem;\n  width: 13rem;\n}\n\n.rightInputContainer {\n  width: 13rem;\n}\n\n.searchCompany {\n  width: 27rem;\n}\n\n.billingShippingContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 2rem;\n  margin-bottom: 1rem;\n}\n\n.twoColumnField {\n  flex: 1;\n}\n\n.addressColumn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fieldSubLabel {\n  font-size: 0.75rem;\n  color: var(--inputGray, #888);\n  margin-top: 2px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userModalContainer": `loginPageStyle_userModalContainer__MMot7`,
	"requiredText": `loginPageStyle_requiredText__KQcko`,
	"inputAdornment": `loginPageStyle_inputAdornment__geFNF`,
	"inputAdornmentIcon": `loginPageStyle_inputAdornmentIcon__E0jf8`,
	"pd": `loginPageStyle_pd__zf94N`,
	"pd2": `loginPageStyle_pd2__joSbH`,
	"pdLeft": `loginPageStyle_pdLeft__6hckg`,
	"pdLeft1": `loginPageStyle_pdLeft1__1cQij`,
	"pdLeftRight": `loginPageStyle_pdLeftRight__KySq5`,
	"pdRight": `loginPageStyle_pdRight__MAAcQ`,
	"pdRight50": `loginPageStyle_pdRight50__IRzIn`,
	"pdbottom": `loginPageStyle_pdbottom__vVbv6`,
	"pdTop": `loginPageStyle_pdTop__2cVbO`,
	"pdRmv": `loginPageStyle_pdRmv__NUO59`,
	"flexClm": `loginPageStyle_flexClm__j3hIN`,
	"flexR": `loginPageStyle_flexR__F6x4Y`,
	"flexRAlgn": `loginPageStyle_flexRAlgn__Vs1ju`,
	"flexRMrg": `loginPageStyle_flexRMrg__-AbbK`,
	"flRg": `loginPageStyle_flRg__lvYoT`,
	"mrg": `loginPageStyle_mrg__i1-Ei`,
	"mrgTop": `loginPageStyle_mrgTop__iSFvS`,
	"mrrg": `loginPageStyle_mrrg__rN5Cv`,
	"mrgLeft": `loginPageStyle_mrgLeft__xNQfP`,
	"containerBtn": `loginPageStyle_containerBtn__E2s+8`,
	"modalCancelBtn": `loginPageStyle_modalCancelBtn__amJ+E`,
	"modalAcceptBtn": `loginPageStyle_modalAcceptBtn__TizRj`,
	"width6": `loginPageStyle_width6__YSE5m`,
	"addressTitle": `loginPageStyle_addressTitle__B5GKF`,
	"smallText": `loginPageStyle_smallText__FcbX7`,
	"cardHeader": `loginPageStyle_cardHeader__RnEG-`,
	"cardtitle": `loginPageStyle_cardtitle__IN643`,
	"forgottenPassword": `loginPageStyle_forgottenPassword__6i7Up`,
	"card": `loginPageStyle_card__qDs7n`,
	"loginCardWidth": `loginPageStyle_loginCardWidth__BvKWB`,
	"cardDraftEdit": `loginPageStyle_cardDraftEdit__8YA2B`,
	"cardDraftEditDisabled": `loginPageStyle_cardDraftEditDisabled__QNT4G`,
	"loginBtn": `loginPageStyle_loginBtn__BJ8t3`,
	"draftCardsHeader": `loginPageStyle_draftCardsHeader__0sjT4`,
	"txAlgn": `loginPageStyle_txAlgn__XS-aE`,
	"headerBcg": `loginPageStyle_headerBcg__y+w0O`,
	"uploadBtn": `loginPageStyle_uploadBtn__2296x`,
	"uploadingRow": `loginPageStyle_uploadingRow__1FF-F`,
	"uploadingRowPulse": `loginPageStyle_uploadingRowPulse__G6m-H`,
	"uploadingPreview": `loginPageStyle_uploadingPreview__Pf+hD`,
	"uploadingShimmer": `loginPageStyle_uploadingShimmer__+jqHb`,
	"uploadingInfo": `loginPageStyle_uploadingInfo__RSXYi`,
	"uploadingName": `loginPageStyle_uploadingName__XtO4B`,
	"uploadingStatus": `loginPageStyle_uploadingStatus__8aTvd`,
	"clrWhite": `loginPageStyle_clrWhite__PBhTU`,
	"draftTitle": `loginPageStyle_draftTitle__79WPX`,
	"draftBtnContainer": `loginPageStyle_draftBtnContainer__rZRP8`,
	"draftBackBtn": `loginPageStyle_draftBackBtn__l-oBx`,
	"draftSaveBtn": `loginPageStyle_draftSaveBtn__xrVM9`,
	"priorityContainer": `loginPageStyle_priorityContainer__hiPLX`,
	"tdContainer": `loginPageStyle_tdContainer__qgzEq`,
	"tdBtnContainer": `loginPageStyle_tdBtnContainer__QmCvD`,
	"checkboxContainer": `loginPageStyle_checkboxContainer__esUtl`,
	"opacity60": `loginPageStyle_opacity60__jgKgT`,
	"dsplInBlock": `loginPageStyle_dsplInBlock__we2Tm`,
	"fontSize90": `loginPageStyle_fontSize90__yzsKd`,
	"fontSize70": `loginPageStyle_fontSize70__y6Cvo`,
	"calcBoldTitle": `loginPageStyle_calcBoldTitle__FH1Ib`,
	"calcTitle": `loginPageStyle_calcTitle__1QxVn`,
	"borderBottomNone": `loginPageStyle_borderBottomNone__H9s57`,
	"fntWeightBold": `loginPageStyle_fntWeightBold__I6veU`,
	"leftInputContainer": `loginPageStyle_leftInputContainer__iPCp9`,
	"rightInputContainer": `loginPageStyle_rightInputContainer__gUKoI`,
	"searchCompany": `loginPageStyle_searchCompany__MvB3s`,
	"billingShippingContainer": `loginPageStyle_billingShippingContainer__EQF4c`,
	"twoColumnField": `loginPageStyle_twoColumnField__6XPb6`,
	"addressColumn": `loginPageStyle_addressColumn__MS7Fy`,
	"fieldSubLabel": `loginPageStyle_fieldSubLabel__nEukJ`
};
export default ___CSS_LOADER_EXPORT___;
